import React, { useState } from "react";
import CheckboxNew from "./CheckboxNew";

/**
 * Example usage of CheckboxNew showing the label + hint (muted subtext)
 * pattern, controlled/uncontrolled, disabled and error states.
 */
const CheckboxNewExample: React.FC = () => {
	const [notifications, setNotifications] = useState(true);
	const [terms, setTerms] = useState(false);

	return (
		<div className="max-w-md mx-auto space-y-6 p-6">
			<h2 className="text-xl font-bold">CheckboxNew Examples</h2>

			{/* Label + hint subtext — the primary pattern */}
			<CheckboxNew
				label="Enable notifications"
				hint="Get an email when something important happens."
				checked={notifications}
				onCheckedChange={setNotifications}
				skipTranslation
			/>

			{/* Label only, no hint */}
			<CheckboxNew
				label="Subscribe to newsletter"
				checked={terms}
				onCheckedChange={setTerms}
				skipTranslation
			/>

			{/* Error state */}
			<CheckboxNew
				label="Accept terms and conditions"
				hint="You must accept before continuing."
				checked={terms}
				onCheckedChange={setTerms}
				errors={terms ? undefined : "This field is required"}
				skipTranslation
			/>

			{/* Disabled, checked */}
			<CheckboxNew
				label="Two-factor authentication"
				hint="Managed by your organisation administrator."
				defaultChecked
				disabled
				skipTranslation
			/>

			{/* Custom styling via className props */}
			<CheckboxNew
				label="Highlighted option"
				hint="Box and label restyled through className props."
				defaultChecked
				skipTranslation
				boxClassName="rounded-full"
				labelClassName="text-brand"
			/>
		</div>
	);
};

export default CheckboxNewExample;
